// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import {router} from './router/index.js'
import moment from 'moment'
import util from './util/util'
import Cookies from 'js-cookie'
import store from './Store/Store'
import axios from 'axios'
import Alert from '@/components/Alert/Alert.vue'
import  VueResource  from 'vue-resource'
import Notifications from "vue-notification"

Vue.use(Notifications)
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

Vue.use(VueResource) 

import { 
  Notification,
} from 'element-ui'
Vue.prototype.$notify = Notification;
Vue.prototype.$func = util
Vue.prototype.$ajax = util.ajax
Vue.prototype.$time = moment
Vue.prototype.$Cookies = Cookies
Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.component('Alert', Alert)

//大图预览插件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
 
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
  beforeMount () {
    util.infoRouter(undefined, this)
  }
})



// WEBPACK FOOTER //
// ./src/main.js